import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=742875fc&scoped=true&"
import script from "./Legends.vue?vue&type=script&lang=js&"
export * from "./Legends.vue?vue&type=script&lang=js&"
import style0 from "./Legends.vue?vue&type=style&index=0&id=742875fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742875fc",
  null
  
)

export default component.exports